import CompanyAppearanceComponent from "../components/CompanyAppearance";
import useCompanyAppearance from "../hooks/useCompanyAppearance";

function CompanyAppearance(props) {
    const companyAppearanceTheme = useCompanyAppearance(props);
    return <CompanyAppearanceComponent {...companyAppearanceTheme} />
}

export default CompanyAppearance;